<div class="mx-auto">
  <div class="hidden sm:block overflow-x-auto">
    <div *ngIf="isLoading" class="flex justify-center items-center h-64">
      <mat-spinner color="accent"></mat-spinner>
    </div>
    <ng-container *ngIf="!isLoading">
      <div class="flex items-center justify-end mb-4 gap-3">
        <mat-select *ngIf="estShowGroupeColumn" [(ngModel)]="selectionGroupe" multiple (selectionChange)="filtre()"
          placeholder="{{ 'CONTENUS_MANAGEMENT.FILTRE_GROUP' | translate }}"
          class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320"
          panelHeight="100">
          <mat-option>
            <ngx-mat-select-search [formControl]="groupFilterCtrl"
              [placeholderLabel]="'CONTENUS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'CONTENUS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let groupe of filteredGroupes | async" [value]="groupe.entiteId">
            <span class="inline-block whitespace-nowrap text-sm">{{ groupe.nom }} <span *ngIf="!groupe.estActif"
                class="text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
              <span
                class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-sm text-gray-700 mr-2 bg-rougeNovo text-white">{{
                groupe.idUnique }}</span>
            </span>
          </mat-option>
        </mat-select>
        <mat-select [(ngModel)]="selectionOrganisation" multiple
          placeholder="{{ 'CONTENUS_MANAGEMENT.FILTRE_ORGANISATION' | translate }}" (selectionChange)="filtre()"
          class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320"
          panelHeight="100">
          <mat-option>
            <ngx-mat-select-search [formControl]="orgFilterCtrl"
              [placeholderLabel]="'CONTENUS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'CONTENUS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let org of filteredOrganisations | async" [value]="org.entiteId">
            <span class="inline-block whitespace-nowrap px-3 py-1 text-sm mr-2">{{ org.nom }}
              <span *ngIf="!org.estActif" class="text-gray-500 m-2">({{ 'ENTITE_INACTIF' | translate }})</span>
              <span
                class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-sm text-gray-700 mr-2 bg-rougeNovo text-white">{{
                org.idUnique }}</span>
            </span>
          </mat-option>
        </mat-select>
        <mat-select placeholder="{{ 'CONTENUS_MANAGEMENT.FILTRE_ETIQUETTE' | translate }}" multiple
          class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320" panelHeight="100"
          [(ngModel)]="selectionEtiquette" (selectionChange)="filtre()">
          <mat-option>
            <ngx-mat-select-search [formControl]="etiquetteFilterCtrl" class="hidden sm:block"
              [placeholderLabel]="'CONTENUS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'CONTENUS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let etq of filteredEtiquettes | async" [value]="etq.etiquetteId">
            <span [style.background-color]="etq.couleur" [style.color]="etiquetteService.obtenirCouleur(etq.couleur)"
              class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-sm text-gray-700 mr-2">
              {{etiquetteService.getNomLocalise(etq.locales)}}
            </span>
          </mat-option>
        </mat-select>
        <mat-select *ngIf="estPageContenuComplete"
          placeholder="{{ 'CONTENUS_MANAGEMENT.FILTRE_FORMATION_GROUPE' | translate }}"
          class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320"
          [(ngModel)]="selectionFormationGroupe" (selectionChange)="filtre()">
          <mat-option [value]="''">{{ 'CONTENUS_MANAGEMENT.TOUS' | translate }}</mat-option>
          <mat-option [value]="'groupe'">{{ 'CONTENUS_MANAGEMENT.FORMATION_EN_GROUPE' | translate }}</mat-option>
          <mat-option [value]="'individuel'">{{ 'CONTENUS_MANAGEMENT.FORMATION_INDIVIDUELLE' | translate }}</mat-option>
        </mat-select>
        <mat-select placeholder="{{ 'CONTENUS_MANAGEMENT.FILTRE_CONTENUS' | translate }}" multiple
          class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320" panelHeight="100"
          [(ngModel)]="selectionTitreContenu" (selectionChange)="filtre()">
          <mat-option>
            <ngx-mat-select-search [formControl]="titreFilterCtrl"
              [placeholderLabel]="'CONTENUS_MANAGEMENT.SEARCH' | translate"
              [noEntriesFoundLabel]="'CONTENUS_MANAGEMENT.NO_RESULTS' | translate">
            </ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let titre of filteredTitres | async" [value]="titre"><span [innerHtml]="titre">{{ titre
              }}</span></mat-option>
        </mat-select>
        <mat-select class="w-1/5 h-8 max-w-[210px] border border-gray-300 rounded-md px-3 py-1" panelWidth="320"
          panelHeight="100" placeholder="{{ 'CONTENUS_MANAGEMENT.FILTRE_DATE_ACCES' | translate }}"
          [(ngModel)]="selectionDateAcces" one (selectionChange)="filtreDateAcces()">
          <mat-option class="w-48 h-10" [value]="'today'"><span>{{ 'CONTENUS_MANAGEMENT.TODAY' |
              translate}}</span></mat-option>
          <mat-option class="w-48 h-10" [value]="'yesterday'"><span>{{ 'CONTENUS_MANAGEMENT.YESTERDAY' |
              translate}}</span></mat-option>
          <mat-option class="w-48 h-10" [value]="'week'"><span>{{ 'CONTENUS_MANAGEMENT.WEEK' |
              translate}}</span></mat-option>
          <mat-option class="w-48 h-10" [value]="'last30days'"><span>{{ 'CONTENUS_MANAGEMENT.LAST30DAYS' |
              translate}}</span></mat-option>
          <mat-option class="w-48 h-10" [value]="'year'"><span>{{ 'CONTENUS_MANAGEMENT.YEAR' |
              translate}}</span></mat-option>
          <mat-option class="w-48 h-10" [value]="'alldate'"><span>{{ 'CONTENUS_MANAGEMENT.ALLDATE' |
              translate}}</span></mat-option>
          <mat-option class="w-48 h-10" [value]="'custom'"><span>{{ 'CONTENUS_MANAGEMENT.CUSTOM_RANGE_DATE' | translate
              }}</span></mat-option>
        </mat-select>
        <div *ngIf="selectionDateAcces === 'custom'"
          class="custom-date-range flex items-center gap-2 w-1/5 h-8 max-w-[235px] border border-gray-300 rounded-md px-3 py-1">
          <mat-date-range-input [rangePicker]="picker" class="flex-1">
            <input title="dateDebut" matStartDate (dateChange)="onDateChange()" [(ngModel)]="dateDebut" />
            <input title="dateFin" matEndDate (dateChange)="onDateChange()" [(ngModel)]="dateFin" />
          </mat-date-range-input>
          <mat-datepicker-toggle matIconSuffix [for]="picker" (click)="resetSelectCustumDate()"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </div>
        <input type="text" [(ngModel)]="textRechercher" (ngModelChange)="filtre()"
          placeholder="{{ 'CONTENUS_MANAGEMENT.SEARCH' | translate }}..."
          class="h-8 w-46 rounded-md border-w-2 border-gray-300 shadow-sm focus:border-red-300 focus:ring focus:ring-red-200">
        <button mat-icon-button (click)="reinitialiserFiltre()" class="h-1/12 w-8 bg-white-200 text-white-600 rounded">
          <mat-icon>restore</mat-icon>
        </button>
      </div>
      <div>
        <div class="w-full overflow-x-auto">
          <table mat-table [dataSource]="dataSource" matSort class="mat-table-novo"
            (matSortChange)="sortDataChange($event)">
            <ng-container matColumnDef="organisation">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2"> {{
                'CONTENUS_MANAGEMENT.ORGANISATION' | translate
                }}</th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{element.organisation.nom |
                tiret }} </td>
            </ng-container>
            <ng-container matColumnDef="groupe" *ngIf="estShowGroupeColumn">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2"> {{
                'CONTENUS_MANAGEMENT.GROUP' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="hidden md:table-cell px-4 py-2 border-b">
                {{element.groupe?.nom | tiret}} </td>
            </ng-container>
            <ng-container matColumnDef="etiquettes">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.TAGS' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="hidden md:table-cell px-4 py-2 border-b">
                <div *ngFor="let etiquette of element.etiquettes" class="mb-2">
                  <span [style.background-color]="etiquette.couleur"
                    [style.color]="etiquetteService.obtenirCouleur(etiquette.couleur)"
                    class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-sm text-gray-700 mr-2">
                    {{etiquetteService.getNomLocalise(etiquette.locales)}}
                  </span>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="prenomNom">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.NAME_LEARNING' | translate
                }}</th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b"> {{element.prenomNom |
                tiret}} </td>
            </ng-container>
            <ng-container matColumnDef="titre">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.TITLE' | translate }}</th>
              <td mat-cell *matCellDef="let element" [innerHtml]="element.titre | tiret "
                class="table-cell px-4 py-2 border-b"></td>
            </ng-container>
            <ng-container *ngIf="estPageContenuComplete" matColumnDef="note">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.NOTE' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="hidden md:table-cell text-center px-4 py-2 border-b">
                {{element.scoreRedimensione != null ? (element.scoreRedimensione * 100 | number:'1.0-0') : (element.note | number:'1.0-0') | tiret }} </td>
            </ng-container>
            <ng-container matColumnDef="duree">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.TIME' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="hidden md:table-cell text-center px-4 py-2 border-b">
                {{element.duree | tiret}} </td>
            </ng-container>
            <ng-container *ngIf="estPageContenuComplete" matColumnDef="dateComplete">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.DATE_COMPLETE' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="table-cell whitespace-nowrap px-4 py-2 border-b"> {{
                momentDate(element.dateComplete).local().format('YYYY-MM-DD HH:mm') | tiret }} </td>
            </ng-container>
            <ng-container *ngIf="!estPageContenuComplete" matColumnDef="dateDernierModification">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.DATE_ACCESS' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">
                {{  momentDate(element.dateDernierModification).local().format('YYYY-MM-DD HH:mm')   | tiret }} </td>
            </ng-container>
            <ng-container *ngIf="!estPageContenuComplete" matColumnDef="dateDemarrage">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.DATE_START' | translate }}
              </th>
              <td mat-cell *matCellDef="let element" class="table-cell px-4 py-2 border-b">{{
              momentDate(element.dateDemarrage).local().format('YYYY-MM-DD HH:mm')  | tiret }} </td>
            </ng-container>
            <ng-container *ngIf="estPageContenuComplete" matColumnDef="estDonneCertificat">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.DONNE_CERTIFICAT' | translate }}</th>
              <td mat-cell *matCellDef="let element" class="hidden md:table-cell px-4 py-2 border-b text-center">
                <mat-icon class="text-center material-symbols-outlined pt-1" [class.hover:cursor-pointer]="!estModeDemo"
                  [class.text-green-700]="!estModeDemo" [class.dark:text-white]="!estModeDemo"
                  [class.text-gray-400]="estModeDemo" [class.cursor-not-allowed]="estModeDemo"
                  [matTooltip]="estModeDemo ? ('CONTENUS_MANAGEMENT.CERTIFICATE_DOWNLOAD_DEMO_TOOLTIP' | translate) : ''"
                  [matTooltipDisabled]="!estModeDemo"
                  (click)="!estModeDemo && telechargerCertificat(element)"
                  *ngIf="element.estDonneCertificat; else noIcon">file_download</mat-icon>
                <ng-template #noIcon><mat-icon
                    class="text-center material-symbols-outlined text-red-700">toggle_off</mat-icon></ng-template>
              </td>
            </ng-container>
            <ng-container *ngIf="estPageContenuComplete" matColumnDef="estCompleteEnGroupe">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="hidden md:table-cell px-4 py-2">{{
                'CONTENUS_MANAGEMENT.COMPLETE_GROUPE' | translate}}</th>
              <td mat-cell *matCellDef="let element" class="hidden md:table-cell px-4 py-2 border-b text-center">
                <mat-icon class="text-center material-symbols-outlined text-green-700"
                  *ngIf="element.estCompleteEnGroupe; else noIcon">toggle_on</mat-icon>
                <ng-template #noIcon><mat-icon
                    class="text-center material-symbols-outlined text-red-700">toggle_off</mat-icon></ng-template>
              </td>
            </ng-container>
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" class="px-2 py-1 text-center">
                <button (click)="obtenirRapportInteraction(element.id)" mat-icon-button
                  class="text-black-500 hover:text-red-700 transform scale-90 sm:scale-100">
                  <mat-icon class="material-icons-outlined">
                    visibility
                  </mat-icon>
                </button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"></tr>
          </table>

          <div *ngIf="dataSource.filteredData.length === 0" class="text-center mt-2 text-gray-500">
            {{ 'COMMUN.DATATABLE_AUCUN_RESULTAT' | translate }}
          </div>

          <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [pageIndex]="pageIndex"
            (page)="paginer($event)" [length]="totalItems" [showFirstLastButtons]="true">
          </mat-paginator>
        </div>
      </div>
      <div class="flex justify-end">
        <a (click)="Retour()">
          <button class="btn-secondary-novo">Retour</button>
        </a>
      </div>
    </ng-container>
  </div>
</div>
